import { SoAPool } from './SoAPool';

export const PickupKind = {
  Cell: 0, // monnaie volatile de la run
  Bomb: 1, // +1 bombe en stock
  /* ── POWER-UPS instantanés (bonus au ramassage) ──────────────────────────
     Lâchés rarement par les ennemis, ils DESCENDENT et se ramassent comme les
     Cell, mais déclenchent un effet immédiat (pickupSystem). */
  Repair: 2, // +1 vie
  Surge: 3, // remplit une part de la jauge d'ulti
  Coolant: 4, // vide instantanément la chauffe du canon
  Overdrive: 5, // suralimentation : cadence ×2 + canon glacé, quelques secondes
} as const;

/** Vrai pour les jetons de POWER-UP (effet instantané), par opposition à la
 *  monnaie `Cell`. Rassemblé ici pour que présentation et sim partagent le même
 *  seuil sans le réécrire. */
export function isPowerup(kind: number): boolean {
  return kind >= PickupKind.Bomb;
}

/** Ramassables. Présents dès le J1 pour que le socle soit complet, mais leur
 *  économie n'existe qu'au J7 : ici ils volent, s'aimantent et se ramassent,
 *  rien de plus. */
export class PickupPool {
  readonly slots: SoAPool;

  readonly x: Float32Array;
  readonly y: Float32Array;
  readonly px: Float32Array;
  readonly py: Float32Array;
  readonly vx: Float32Array;
  readonly vy: Float32Array;
  readonly kind: Uint8Array;
  readonly age: Float32Array;

  constructor(capacity: number) {
    this.slots = new SoAPool(capacity);
    this.x = new Float32Array(capacity);
    this.y = new Float32Array(capacity);
    this.px = new Float32Array(capacity);
    this.py = new Float32Array(capacity);
    this.vx = new Float32Array(capacity);
    this.vy = new Float32Array(capacity);
    this.kind = new Uint8Array(capacity);
    this.age = new Float32Array(capacity);
  }

  get count(): number {
    return this.slots.count;
  }
  at(i: number): number {
    return this.slots.at(i);
  }

  spawn(kind: number, x: number, y: number, vx: number, vy: number): number {
    const s = this.slots.alloc();
    if (s < 0) return -1;
    this.x[s] = x;
    this.y[s] = y;
    this.px[s] = x;
    this.py[s] = y;
    this.vx[s] = vx;
    this.vy[s] = vy;
    this.kind[s] = kind;
    this.age[s] = 0;
    return s;
  }

  free(slot: number): void {
    this.slots.free(slot);
  }
  clear(): void {
    this.slots.clear();
  }

  savePrev(): void {
    const n = this.slots.count;
    for (let i = 0; i < n; i++) {
      const s = this.slots.at(i);
      this.px[s] = this.x[s]!;
      this.py[s] = this.y[s]!;
    }
  }
}
